import * as React from "react";
import "./presenter.scss";
import {option} from "ts-option";
import AssigneesPresenterComponent from "./AssigneesPresenterComponent";

interface IProps {
	value: {
		agentId: string;
		businessDevelopmentPartnerId: string;
	};
}

export const AssigneesPresenter: React.SFC<IProps> = (props) => {
	return (
		<AssigneesPresenterComponent agentId={option(props.value && props.value.agentId)} bdpId={option(props.value && props.value.businessDevelopmentPartnerId)} />
	);
};

